import { PowerUpButtonsContainer } from "./PowerUpButtonsContainer";
import { PauseMenu } from "./PauseMenu";
import { GameVars } from "../GameVars";
import { MatchManager } from "../MatchManager";
import { AudioManager } from "../AudioManager";

export class GUI extends Phaser.Group {

    public static currentInstance: GUI;

    public optionsMenuButton: Phaser.Button;
    public powerUpButtonsContainer: PowerUpButtonsContainer;
    public pauseMenu: PauseMenu;

    constructor(game: Phaser.Game) {

        super(game, null, "gui", false);

        GUI.currentInstance = this;

        this.optionsMenuButton = new Phaser.Button(this.game, 636, 4, "texture_atlas_5", this.onClickOptionsMenu, this, 1, 0, 1);
        this.optionsMenuButton.setFrames("options_button_on", "options_button_off", "options_button_on");
        this.optionsMenuButton.forceOut = true;
        this.optionsMenuButton.scale.y = GameVars.scaleY;
        this.optionsMenuButton.visible = false;
        this.add(this.optionsMenuButton);

        this.powerUpButtonsContainer = new PowerUpButtonsContainer(this.game);
        this.add(this.powerUpButtonsContainer);

        this.pauseMenu = new PauseMenu(this.game, this);
        this.pauseMenu.visible = false;
        this.add(this.pauseMenu);
    }

    public destroy(destroyChildren?: boolean, soft?: boolean): void {

        GUI.currentInstance = null;

        super.destroy(destroyChildren, soft);
    }

    public start(): void {

        this.optionsMenuButton.visible = true;

        this.powerUpButtonsContainer.onBallsManagerReadyToKickOff();
    }

    public onKickOff(): void {

        this.powerUpButtonsContainer.onKickOff();
    }

    public hideMenuContainer(): void {

        if (!GameVars.paused) {  
            return;
        }

        this.pauseMenu.hide();

        this.optionsMenuButton.visible = true;
        this.powerUpButtonsContainer.updatePowerUpButtons();

        MatchManager.onResume();
    }

    public onClickOptionsMenu(): void {

        if (GameVars.paused) {  
            return;
        }

        if (GameVars.isTimedLevel) {
            this.game.time.events.pause();
        }

        MatchManager.onPause();

        this.optionsMenuButton.visible = false;
        this.pauseMenu.show();

        AudioManager.getInstance().playEffect("play");
        AudioManager.getInstance().setVolumePlayingMusic(.4);
    }
}
